let inputCounter = 0;
let nextNumber = 0;

/*Used to give every input a unique id*/
export const getNextInputId = function(){
	if(inputCounter > 99999)
		inputCounter = 0;
	
	inputCounter++;
	return `input_${inputCounter - 1}`;
}

export const getNextNumber = function(){
	if(nextNumber > 99999)
		nextNumber = 0;	
	nextNumber++;
	return nextNumber -1;
}

export function prettyNumber(num){
	let rVal = num.toString();
	if(num < 10)
		return `0${rVal}`;
	return num;

} 